import React from 'react';
import { ReactComponent as ExclamationIcon } from '@blink/assets/src/icons/exclamation.svg';

import { useAssetInputStyle } from './LeverageInput.style';

import { TooltipWrapper } from '@/shared/ui';

type AssetInputSupplyTooltipProps = {
    apy?: string;
    handleMaxClick: () => void;
};

export const LeverageInputTooltip = ({ apy, handleMaxClick }: AssetInputSupplyTooltipProps) => {
    const classes = useAssetInputStyle();

    return (
        <div className={classes.title}>
            {' '}
            Borrow APY &nbsp;
            <span className={classes.text} onClick={handleMaxClick}>
                {apy}%
            </span>
            <TooltipWrapper
                text="The annual percentage yield you pay for borrowing assets from the pool. The rate
                    fluctuates based on the pool's utilization and prevailing interest rates, impacting your
                    total borrowing cost"
                icon={<ExclamationIcon />}
            />
        </div>
    );
};
